// CollapsibleSection.tsx
import React, { useState } from "react";

interface CollapsibleSectionProps {
	title: string;
	children: React.ReactNode;
}

export const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
	title,
	children,
}) => {
	const [isOpen, setIsOpen] = useState(false);

	return (
		<section className="border-b border-gray-200">
			<button
				className="w-full flex justify-between items-center py-3 px-2 bg-[var(--semantic-bg-primary)]"
				onClick={() => setIsOpen(!isOpen)}
			>
				<span className="font-semibold text-sm text-semantic-text-primary">
					{title}
				</span>
				<span className="ml-2 text-xl">{isOpen ? "−" : "+"}</span>
			</button>
			{isOpen && (
				<div className="bg-[var(--semantic-bg-secondary)] p-4">{children}</div>
			)}
		</section>
	);
};
